import {
  DEFAULT_ENTRY_POINT,
  EntryPoint,
} from "@/modules/tracking/consts/EntryPoints";
import {
  registerSuperProperties,
  unregisterSuperProperty,
} from "@/modules/tracking/utils/registerSuperProperties";

// Registers the booking-flow super properties for a given entry-point.
// Branches on whether a customer id is known so a previously-registered
// value can be cleared from localStorage on the anonymous branch; without
// the explicit clear, an earlier identified visit's `customer_id` would
// leak into a later anonymous visit on the same browser.
export function registerBookingSuperProperties({
  customerId,
  entryPoint,
}: {
  customerId?: number;
  entryPoint?: EntryPoint;
}): void {
  const resolvedEntryPoint = entryPoint ?? DEFAULT_ENTRY_POINT;

  if (customerId !== undefined) {
    registerSuperProperties({
      entry_point: resolvedEntryPoint,
      customer_id: customerId,
    });
    return;
  }

  registerSuperProperties({ entry_point: resolvedEntryPoint });
  unregisterSuperProperty("customer_id");
}
